import React, { useState } from 'react';
import { 
  Building2, Users, FileText, Upload, CheckCircle, 
  ChevronRight, ChevronLeft, Send, AlertCircle,
  User, Mail, Phone, MapPin, Briefcase, Calendar,
  Shield, Heart, ClipboardList
} from 'lucide-react';
import axios from 'axios';

const QuotazioneForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [errors, setErrors] = useState({});
  
  const [formData, setFormData] = useState({
    // Sezione 1: Dati Anagrafici
    ente: '',
    codiceFiscale: '',
    indirizzo: '',
    capCitta: '',
    email: '',
    telefono: '',
    referente: '',
    
    // Sezione 2: Profilo dell'Ente
    tipologiaEnte: '',
    descrizioneAttivita: [],
    descrizioneAttivitaAltro: '',
    iscrittoRUNTS: '',
    
    // Sezione 3: Dettagli della Richiesta
    richiestaContatto: [],
    richiestaContattoAltro: '',
    presenzaProfessionisti: [],
    presenzaProfessionistiAltro: '',
    
    // Sezione 4: Dati Quantitativi
    fatturatoAnnuo: '',
    numeroIscritti: '',
    numeroUtenti: '',
    numeroVolontari: '',
    registroVolontariVidimato: '',
    dataInizioEvento: '',
    dataFineEvento: '',
    sinistroRCT: '',
    sinistroRCTSpecifica: '',
    sinistroInfortuni: '',
    sinistroInfortuniSpecifica: '',
    
    // Sezione 5: Documenti
    files: {
      statuto: null,
      registroVolontari: null,
      documentoIdentita: null,
      documentazioneBando: null,
      polizzaAttuale: null
    },
    
    // Sezione 6: Consenso
    consensoConsulenza: false
  });

  const totalSteps = 6;

  const tipologieEnte = [
    'Altri enti del terzo settore',
    'APS',
    'Botteghe del mondo',
    'Consorzio imprese',
    'Ente Religioso',
    'Ente Filantropico/Fondazione',
    'Impresa Impatto',
    'Impresa Sociale/Coop Sociale',
    'Cooperativa',
    'ODV',
    'Rete associativa',
    'Società di Mutuo Soccorso'
  ];

  const descrizioniAttivita = [
    'Assistenza sociale',
    'Attività sociali/culturali/educative',
    'Case di Riposo',
    'Comunità alloggio',
    'Comunità terapeutiche',
    'Gestione centri diurni',
    'Scuole materne/asili',
    'Erogazione assistenza medico/sanitaria'
  ];

  const richiesteContatto = [
    'Coperture Obbligatorie Volontari',
    'RCT Ente/Coop',
    'Infortuni Soci/Utenti',
    'D&O (Responsabilità Amministratori)',
    'RC Tirocinanti',
    'Tutela Legale',
    'Copertura beni (Sedi/Arredi)',
    'RC Auto/Flotte',
    'Fidejussioni',
    'Saggi/Eventi',
    'Colonie/Soggiorni',
    'Progetti DOPO DI NOI',
    'INCLUDIS'
  ];

  const professioniMediche = [
    'Infermieri (Dipendenti)',
    'Infermieri (Liberi Professionisti)',
    'Medici (Dipendenti)',
    'Medici (Liberi Professionisti)',
    'Fisioterapisti',
    'OSS',
    'Nessuna professione medica'
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      if (name.includes('[]')) {
        const fieldName = name.replace('[]', '');
        setFormData(prev => ({
          ...prev,
          [fieldName]: checked 
            ? [...prev[fieldName], value]
            : prev[fieldName].filter(item => item !== value)
        }));
      } else {
        setFormData(prev => ({ ...prev, [name]: checked }));
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
    
    // Clear error when field is modified
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        setErrors(prev => ({ ...prev, [fieldName]: 'Il file supera i 10MB consentiti' }));
        return;
      }
      // Validate file type
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        setErrors(prev => ({ ...prev, [fieldName]: 'Formato non supportato. Usa PDF, JPG o PNG' }));
        return;
      }
      setFormData(prev => ({
        ...prev,
        files: { ...prev.files, [fieldName]: file }
      }));
      setErrors(prev => ({ ...prev, [fieldName]: null }));
    }
  };

  const validateStep = (step) => {
    const newErrors = {};
    
    switch(step) {
      case 1:
        if (!formData.ente) newErrors.ente = 'Campo obbligatorio';
        if (!formData.codiceFiscale) newErrors.codiceFiscale = 'Campo obbligatorio';
        if (!formData.indirizzo) newErrors.indirizzo = 'Campo obbligatorio';
        if (!formData.capCitta) newErrors.capCitta = 'Campo obbligatorio';
        if (!formData.email) newErrors.email = 'Campo obbligatorio';
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = 'Email non valida';
        if (!formData.telefono) newErrors.telefono = 'Campo obbligatorio';
        if (!formData.referente) newErrors.referente = 'Campo obbligatorio';
        break;
      case 2:
        if (!formData.tipologiaEnte) newErrors.tipologiaEnte = 'Seleziona una tipologia';
        if (!formData.iscrittoRUNTS) newErrors.iscrittoRUNTS = 'Campo obbligatorio';
        break;
      case 3:
        if (formData.richiestaContatto.length === 0) newErrors.richiestaContatto = 'Seleziona almeno un\'opzione';
        break;
      case 4:
        if (!formData.numeroIscritti) newErrors.numeroIscritti = 'Campo obbligatorio';
        break;
      case 6:
        if (!formData.consensoConsulenza) newErrors.consensoConsulenza = 'Il consenso è obbligatorio';
        break;
      default:
        break;
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const nextStep = () => {
    if (validateStep(currentStep)) {
      setCurrentStep(prev => Math.min(prev + 1, totalSteps));
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateStep(currentStep)) return;
    
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Prepare form data for submission
      const submitData = new FormData();
      
      // Add all text fields
      Object.keys(formData).forEach(key => {
        if (key !== 'files') {
          if (Array.isArray(formData[key])) {
            submitData.append(key, formData[key].join(', '));
          } else {
            submitData.append(key, formData[key]);
          }
        }
      });
      
      // Add files
      Object.keys(formData.files).forEach(key => {
        if (formData.files[key]) {
          submitData.append(key, formData.files[key]);
        }
      });

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/quotazione`,
        submitData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.status === 'success') {
        setSubmitStatus('success');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Errore invio:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Check if "Saggi/Eventi" is selected to show date fields
  const showEventDates = formData.richiestaContatto.includes('Saggi/Eventi');

  const stepIcons = {
    1: Building2,
    2: Briefcase,
    3: ClipboardList,
    4: Users,
    5: Upload,
    6: CheckCircle
  };

  const stepTitles = {
    1: 'Dati Anagrafici',
    2: 'Profilo Ente',
    3: 'Dettagli Richiesta',
    4: 'Dati Quantitativi',
    5: 'Documenti',
    6: 'Conferma'
  };

  const renderStepIndicator = () => (
    <div className="mb-8">
      <div className="flex justify-between items-center">
        {[1, 2, 3, 4, 5, 6].map((step) => {
          const Icon = stepIcons[step];
          const isActive = currentStep === step;
          const isCompleted = currentStep > step;
          
          return (
            <div key={step} className="flex-1 flex items-center">
              <div className="flex flex-col items-center w-full">
                <div 
                  className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                    isActive 
                      ? 'bg-[#2B7A9F] text-white shadow-lg scale-110' 
                      : isCompleted 
                        ? 'bg-[#5FB76E] text-white' 
                        : 'bg-gray-200 text-gray-500'
                  }`}
                >
                  {isCompleted ? <CheckCircle size={20} /> : <Icon size={20} />}
                </div>
                <span className={`text-xs mt-2 text-center hidden sm:block ${
                  isActive ? 'text-[#2B7A9F] font-semibold' : 'text-gray-500'
                }`}>
                  {stepTitles[step]}
                </span>
              </div>
              {step < 6 && (
                <div className={`flex-1 h-1 mx-2 rounded ${
                  currentStep > step ? 'bg-[#5FB76E]' : 'bg-gray-200'
                }`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );

  const renderStep1 = () => (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-[#2B7A9F]/10 rounded-lg flex items-center justify-center">
          <Building2 className="text-[#2B7A9F]" size={20} />
        </div>
        <h3 className="text-xl font-bold text-[#2B7A9F]">Dati Anagrafici</h3>
      </div>
      
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nome Ente <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="ente"
            value={formData.ente}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 rounded-lg border ${errors.ente ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#2B7A9F] focus:border-transparent transition-all`}
            placeholder="Denominazione dell'ente"
          />
          {errors.ente && <p className="text-red-500 text-sm mt-1">{errors.ente}</p>}
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Codice Fiscale / P.IVA <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="codiceFiscale"
            value={formData.codiceFiscale}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 rounded-lg border ${errors.codiceFiscale ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#2B7A9F] focus:border-transparent transition-all`}
            placeholder="00000000000"
          />
          {errors.codiceFiscale && <p className="text-red-500 text-sm mt-1">{errors.codiceFiscale}</p>}
        </div>
        
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Indirizzo <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <MapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
            <input
              type="text"
              name="indirizzo"
              value={formData.indirizzo}
              onChange={handleInputChange}
              className={`w-full pl-10 pr-4 py-3 rounded-lg border ${errors.indirizzo ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#2B7A9F] focus:border-transparent transition-all`}
              placeholder="Via/Piazza e numero civico"
            />
          </div>
          {errors.indirizzo && <p className="text-red-500 text-sm mt-1">{errors.indirizzo}</p>}
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            CAP e Città <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="capCitta"
            value={formData.capCitta}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 rounded-lg border ${errors.capCitta ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#2B7A9F] focus:border-transparent transition-all`}
            placeholder="00000 Città (Provincia)"
          />
          {errors.capCitta && <p className="text-red-500 text-sm mt-1">{errors.capCitta}</p>}
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className={`w-full pl-10 pr-4 py-3 rounded-lg border ${errors.email ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#2B7A9F] focus:border-transparent transition-all`}
              placeholder="email@esempio.it"
            />
          </div>
          {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Telefono <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
            <input
              type="tel"
              name="telefono"
              value={formData.telefono}
              onChange={handleInputChange}
              className={`w-full pl-10 pr-4 py-3 rounded-lg border ${errors.telefono ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#2B7A9F] focus:border-transparent transition-all`}
              placeholder="+39 000 000 0000"
            />
          </div>
          {errors.telefono && <p className="text-red-500 text-sm mt-1">{errors.telefono}</p>}
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Referente <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
            <input
              type="text"
              name="referente"
              value={formData.referente}
              onChange={handleInputChange}
              className={`w-full pl-10 pr-4 py-3 rounded-lg border ${errors.referente ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#2B7A9F] focus:border-transparent transition-all`}
              placeholder="Nome e Cognome"
            />
          </div>
          {errors.referente && <p className="text-red-500 text-sm mt-1">{errors.referente}</p>}
        </div>
      </div>
    </div>
  );

  const renderStep2 = () => (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-[#3AAFA9]/10 rounded-lg flex items-center justify-center">
          <Briefcase className="text-[#3AAFA9]" size={20} />
        </div>
        <h3 className="text-xl font-bold text-[#3AAFA9]">Profilo dell'Ente</h3>
      </div>
      
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tipologia Ente <span className="text-red-500">*</span>
          </label>
          <select
            name="tipologiaEnte"
            value={formData.tipologiaEnte}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 rounded-lg border ${errors.tipologiaEnte ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#3AAFA9] focus:border-transparent transition-all bg-white`}
          >
            <option value="">Seleziona tipologia...</option>
            {tipologieEnte.map(tipo => (
              <option key={tipo} value={tipo}>{tipo}</option>
            ))}
          </select>
          {errors.tipologiaEnte && <p className="text-red-500 text-sm mt-1">{errors.tipologiaEnte}</p>}
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Descrizione dell'attività
          </label>
          <div className="grid sm:grid-cols-2 gap-3">
            {descrizioniAttivita.map(desc => (
              <label key={desc} className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                <input
                  type="checkbox"
                  name="descrizioneAttivita[]"
                  value={desc}
                  checked={formData.descrizioneAttivita.includes(desc)}
                  onChange={handleInputChange}
                  className="mt-1 w-4 h-4 text-[#3AAFA9] rounded focus:ring-[#3AAFA9]"
                />
                <span className="text-sm text-gray-700">{desc}</span>
              </label>
            ))}
          </div>
          <div className="mt-3">
            <input
              type="text"
              name="descrizioneAttivitaAltro"
              value={formData.descrizioneAttivitaAltro}
              onChange={handleInputChange}
              placeholder="Altro (specificare)..."
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#3AAFA9] focus:border-transparent transition-all"
            />
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Iscritto al RUNTS? <span className="text-red-500">*</span>
          </label>
          <div className="flex space-x-4">
            <label className={`flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all ${
              formData.iscrittoRUNTS === 'si' 
                ? 'border-[#5FB76E] bg-[#5FB76E]/5' 
                : 'border-gray-200 hover:border-gray-300'
            }`}>
              <input
                type="radio"
                name="iscrittoRUNTS"
                value="si"
                checked={formData.iscrittoRUNTS === 'si'}
                onChange={handleInputChange}
                className="sr-only"
              />
              <div className="flex items-center justify-center space-x-2">
                <CheckCircle className={formData.iscrittoRUNTS === 'si' ? 'text-[#5FB76E]' : 'text-gray-400'} size={20} />
                <span className={formData.iscrittoRUNTS === 'si' ? 'font-semibold text-[#5FB76E]' : 'text-gray-600'}>Sì</span>
              </div>
            </label>
            <label className={`flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all ${
              formData.iscrittoRUNTS === 'no' 
                ? 'border-[#E74C3C] bg-[#E74C3C]/5' 
                : 'border-gray-200 hover:border-gray-300'
            }`}>
              <input
                type="radio"
                name="iscrittoRUNTS"
                value="no"
                checked={formData.iscrittoRUNTS === 'no'}
                onChange={handleInputChange}
                className="sr-only"
              />
              <div className="flex items-center justify-center space-x-2">
                <AlertCircle className={formData.iscrittoRUNTS === 'no' ? 'text-[#E74C3C]' : 'text-gray-400'} size={20} />
                <span className={formData.iscrittoRUNTS === 'no' ? 'font-semibold text-[#E74C3C]' : 'text-gray-600'}>No</span>
              </div>
            </label>
          </div>
          {errors.iscrittoRUNTS && <p className="text-red-500 text-sm mt-1">{errors.iscrittoRUNTS}</p>}
        </div>
      </div>
    </div>
  );

  const renderStep3 = () => (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-[#5FB76E]/10 rounded-lg flex items-center justify-center">
          <ClipboardList className="text-[#5FB76E]" size={20} />
        </div>
        <h3 className="text-xl font-bold text-[#5FB76E]">Dettagli della Richiesta</h3>
      </div>
      
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Richiesta contatto per <span className="text-red-500">*</span>
          </label>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {richiesteContatto.map(richiesta => (
              <label key={richiesta} className={`flex items-start space-x-3 p-3 rounded-lg border-2 cursor-pointer transition-all ${
                formData.richiestaContatto.includes(richiesta)
                  ? 'border-[#5FB76E] bg-[#5FB76E]/5'
                  : 'border-gray-200 hover:border-gray-300 bg-gray-50'
              }`}>
                <input
                  type="checkbox"
                  name="richiestaContatto[]"
                  value={richiesta}
                  checked={formData.richiestaContatto.includes(richiesta)}
                  onChange={handleInputChange}
                  className="mt-1 w-4 h-4 text-[#5FB76E] rounded focus:ring-[#5FB76E]"
                />
                <span className="text-sm text-gray-700">{richiesta}</span>
              </label>
            ))}
          </div>
          <div className="mt-3">
            <input
              type="text"
              name="richiestaContattoAltro"
              value={formData.richiestaContattoAltro}
              onChange={handleInputChange}
              placeholder="Altro (specificare)..."
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#5FB76E] focus:border-transparent transition-all"
            />
          </div>
          {errors.richiestaContatto && <p className="text-red-500 text-sm mt-1">{errors.richiestaContatto}</p>}
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Presenza di Professionisti campo Medico
          </label>
          <div className="grid sm:grid-cols-2 gap-3">
            {professioniMediche.map(prof => (
              <label key={prof} className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                <input
                  type="checkbox"
                  name="presenzaProfessionisti[]"
                  value={prof}
                  checked={formData.presenzaProfessionisti.includes(prof)}
                  onChange={handleInputChange}
                  className="mt-1 w-4 h-4 text-[#5FB76E] rounded focus:ring-[#5FB76E]"
                />
                <span className="text-sm text-gray-700">{prof}</span>
              </label>
            ))}
          </div>
          <div className="mt-3">
            <input
              type="text"
              name="presenzaProfessionistiAltro"
              value={formData.presenzaProfessionistiAltro}
              onChange={handleInputChange}
              placeholder="Altro (specificare)..."
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#5FB76E] focus:border-transparent transition-all"
            />
          </div>
        </div>
      </div>
    </div>
  );

  const renderStep4 = () => (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-[#E67E22]/10 rounded-lg flex items-center justify-center">
          <Users className="text-[#E67E22]" size={20} />
        </div>
        <h3 className="text-xl font-bold text-[#E67E22]">Dati Quantitativi e Storico</h3>
      </div>
      
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Fatturato annuo lordo (€)
          </label>
          <input
            type="number"
            name="fatturatoAnnuo"
            value={formData.fatturatoAnnuo}
            onChange={handleInputChange}
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#E67E22] focus:border-transparent transition-all"
            placeholder="0,00"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Numero iscritti/associati/soci <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            name="numeroIscritti"
            value={formData.numeroIscritti}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 rounded-lg border ${errors.numeroIscritti ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#E67E22] focus:border-transparent transition-all`}
            placeholder="0"
          />
          {errors.numeroIscritti && <p className="text-red-500 text-sm mt-1">{errors.numeroIscritti}</p>}
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Numero Utenti
          </label>
          <input
            type="number"
            name="numeroUtenti"
            value={formData.numeroUtenti}
            onChange={handleInputChange}
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#E67E22] focus:border-transparent transition-all"
            placeholder="0"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Numero Volontari (da registro vidimato)
          </label>
          <input
            type="number"
            name="numeroVolontari"
            value={formData.numeroVolontari}
            onChange={handleInputChange}
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#E67E22] focus:border-transparent transition-all"
            placeholder="0"
          />
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-3">
          Esiste Registro dei Volontari VIDIMATO?
        </label>
        <div className="flex space-x-4">
          <label className={`flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all ${
            formData.registroVolontariVidimato === 'si' 
              ? 'border-[#5FB76E] bg-[#5FB76E]/5' 
              : 'border-gray-200 hover:border-gray-300'
          }`}>
            <input
              type="radio"
              name="registroVolontariVidimato"
              value="si"
              checked={formData.registroVolontariVidimato === 'si'}
              onChange={handleInputChange}
              className="sr-only"
            />
            <div className="flex items-center justify-center space-x-2">
              <span className={formData.registroVolontariVidimato === 'si' ? 'font-semibold text-[#5FB76E]' : 'text-gray-600'}>Sì</span>
            </div>
          </label>
          <label className={`flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all ${
            formData.registroVolontariVidimato === 'no' 
              ? 'border-[#E74C3C] bg-[#E74C3C]/5' 
              : 'border-gray-200 hover:border-gray-300'
          }`}>
            <input
              type="radio"
              name="registroVolontariVidimato"
              value="no"
              checked={formData.registroVolontariVidimato === 'no'}
              onChange={handleInputChange}
              className="sr-only"
            />
            <div className="flex items-center justify-center space-x-2">
              <span className={formData.registroVolontariVidimato === 'no' ? 'font-semibold text-[#E74C3C]' : 'text-gray-600'}>No</span>
            </div>
          </label>
        </div>
      </div>
      
      {/* Conditional: Date fields for Events */}
      {showEventDates && (
        <div className="bg-[#F9D424]/10 rounded-xl p-6 border border-[#F9D424]/30 animate-fade-in">
          <div className="flex items-center space-x-2 mb-4">
            <Calendar className="text-[#E67E22]" size={20} />
            <h4 className="font-semibold text-gray-800">Assicurazione Singolo Evento</h4>
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Data Inizio Evento
              </label>
              <input
                type="date"
                name="dataInizioEvento"
                value={formData.dataInizioEvento}
                onChange={handleInputChange}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#E67E22] focus:border-transparent transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Data Fine Evento
              </label>
              <input
                type="date"
                name="dataFineEvento"
                value={formData.dataFineEvento}
                onChange={handleInputChange}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#E67E22] focus:border-transparent transition-all"
              />
            </div>
          </div>
        </div>
      )}
      
      {/* Sinistri */}
      <div className="space-y-4">
        <div className="bg-gray-50 rounded-xl p-6">
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Sinistri RCT negli ultimi 3 anni?
          </label>
          <div className="flex space-x-4 mb-3">
            <label className={`flex-1 p-3 rounded-lg border-2 cursor-pointer transition-all text-center ${
              formData.sinistroRCT === 'si' ? 'border-[#E74C3C] bg-[#E74C3C]/5' : 'border-gray-200'
            }`}>
              <input type="radio" name="sinistroRCT" value="si" checked={formData.sinistroRCT === 'si'} onChange={handleInputChange} className="sr-only" />
              <span className={formData.sinistroRCT === 'si' ? 'font-semibold text-[#E74C3C]' : 'text-gray-600'}>Sì</span>
            </label>
            <label className={`flex-1 p-3 rounded-lg border-2 cursor-pointer transition-all text-center ${
              formData.sinistroRCT === 'no' ? 'border-[#5FB76E] bg-[#5FB76E]/5' : 'border-gray-200'
            }`}>
              <input type="radio" name="sinistroRCT" value="no" checked={formData.sinistroRCT === 'no'} onChange={handleInputChange} className="sr-only" />
              <span className={formData.sinistroRCT === 'no' ? 'font-semibold text-[#5FB76E]' : 'text-gray-600'}>No</span>
            </label>
          </div>
          {formData.sinistroRCT === 'si' && (
            <input
              type="text"
              name="sinistroRCTSpecifica"
              value={formData.sinistroRCTSpecifica}
              onChange={handleInputChange}
              placeholder="Specifica i sinistri..."
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#E67E22] focus:border-transparent transition-all"
            />
          )}
        </div>
        
        <div className="bg-gray-50 rounded-xl p-6">
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Sinistri Infortuni negli ultimi 3 anni?
          </label>
          <div className="flex space-x-4 mb-3">
            <label className={`flex-1 p-3 rounded-lg border-2 cursor-pointer transition-all text-center ${
              formData.sinistroInfortuni === 'si' ? 'border-[#E74C3C] bg-[#E74C3C]/5' : 'border-gray-200'
            }`}>
              <input type="radio" name="sinistroInfortuni" value="si" checked={formData.sinistroInfortuni === 'si'} onChange={handleInputChange} className="sr-only" />
              <span className={formData.sinistroInfortuni === 'si' ? 'font-semibold text-[#E74C3C]' : 'text-gray-600'}>Sì</span>
            </label>
            <label className={`flex-1 p-3 rounded-lg border-2 cursor-pointer transition-all text-center ${
              formData.sinistroInfortuni === 'no' ? 'border-[#5FB76E] bg-[#5FB76E]/5' : 'border-gray-200'
            }`}>
              <input type="radio" name="sinistroInfortuni" value="no" checked={formData.sinistroInfortuni === 'no'} onChange={handleInputChange} className="sr-only" />
              <span className={formData.sinistroInfortuni === 'no' ? 'font-semibold text-[#5FB76E]' : 'text-gray-600'}>No</span>
            </label>
          </div>
          {formData.sinistroInfortuni === 'si' && (
            <input
              type="text"
              name="sinistroInfortuniSpecifica"
              value={formData.sinistroInfortuniSpecifica}
              onChange={handleInputChange}
              placeholder="Specifica i sinistri..."
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#E67E22] focus:border-transparent transition-all"
            />
          )}
        </div>
      </div>
    </div>
  );

  const renderStep5 = () => (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-[#9B59B6]/10 rounded-lg flex items-center justify-center">
          <Upload className="text-[#9B59B6]" size={20} />
        </div>
        <h3 className="text-xl font-bold text-[#9B59B6]">Caricamento Documenti</h3>
      </div>
      
      <p className="text-sm text-gray-600 mb-6">
        Carica i documenti richiesti (PDF, JPG, PNG - max 10MB per file). I documenti non sono obbligatori ma velocizzano la quotazione.
      </p>
      
      <div className="space-y-4">
        {[
          { key: 'statuto', label: 'Statuto / Atto Costitutivo', icon: FileText },
          { key: 'registroVolontari', label: 'Registro dei Volontari Vidimato', icon: Users },
          { key: 'documentoIdentita', label: 'Documento Identità e CF Amministratore', icon: User },
          { key: 'documentazioneBando', label: 'Documentazione Bando/Aggiudicazione (per PA)', icon: ClipboardList },
          { key: 'polizzaAttuale', label: 'Polizza attuale per verifica', icon: Shield }
        ].map(({ key, label, icon: Icon }) => (
          <div key={key} className="bg-gray-50 rounded-xl p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <Icon className="text-[#9B59B6]" size={20} />
                <span className="text-sm font-medium text-gray-700">{label}</span>
              </div>
              <div className="flex items-center space-x-3">
                {formData.files[key] && (
                  <span className="text-sm text-[#5FB76E] flex items-center">
                    <CheckCircle size={16} className="mr-1" />
                    {formData.files[key].name.substring(0, 20)}...
                  </span>
                )}
                <label className="cursor-pointer bg-white px-4 py-2 rounded-lg border border-gray-300 hover:border-[#9B59B6] hover:bg-[#9B59B6]/5 transition-all text-sm font-medium text-gray-700">
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => handleFileChange(e, key)}
                    className="sr-only"
                  />
                  {formData.files[key] ? 'Cambia' : 'Carica'}
                </label>
              </div>
            </div>
            {errors[key] && <p className="text-red-500 text-sm mt-2">{errors[key]}</p>}
          </div>
        ))}
      </div>
    </div>
  );

  const renderStep6 = () => (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-[#5FB76E]/10 rounded-lg flex items-center justify-center">
          <CheckCircle className="text-[#5FB76E]" size={20} />
        </div>
        <h3 className="text-xl font-bold text-[#5FB76E]">Conferma e Invio</h3>
      </div>
      
      {/* Summary */}
      <div className="bg-gray-50 rounded-xl p-6 space-y-4">
        <h4 className="font-semibold text-gray-800 mb-4">Riepilogo della richiesta</h4>
        <div className="grid md:grid-cols-2 gap-4 text-sm">
          <div>
            <span className="text-gray-500">Ente:</span>
            <p className="font-medium">{formData.ente || '-'}</p>
          </div>
          <div>
            <span className="text-gray-500">Tipologia:</span>
            <p className="font-medium">{formData.tipologiaEnte || '-'}</p>
          </div>
          <div>
            <span className="text-gray-500">Email:</span>
            <p className="font-medium">{formData.email || '-'}</p>
          </div>
          <div>
            <span className="text-gray-500">Referente:</span>
            <p className="font-medium">{formData.referente || '-'}</p>
          </div>
          <div className="md:col-span-2">
            <span className="text-gray-500">Richiesta per:</span>
            <p className="font-medium">{formData.richiestaContatto.join(', ') || '-'}</p>
          </div>
        </div>
      </div>
      
      {/* Consent */}
      <div className={`p-6 rounded-xl border-2 ${errors.consensoConsulenza ? 'border-red-500 bg-red-50' : 'border-gray-200 bg-white'}`}>
        <label className="flex items-start space-x-3 cursor-pointer">
          <input
            type="checkbox"
            name="consensoConsulenza"
            checked={formData.consensoConsulenza}
            onChange={handleInputChange}
            className="mt-1 w-5 h-5 text-[#5FB76E] rounded focus:ring-[#5FB76E]"
          />
          <span className="text-sm text-gray-700">
            Dichiaro di aver preso visione dell'<a href="/privacy-policy" className="text-[#2B7A9F] underline" target="_blank" rel="noopener noreferrer">Informativa Privacy</a> (Reg. UE 2016/679) e <strong>acconsento</strong> al trattamento dei miei dati per la gestione della richiesta, nonché alla consulenza a distanza attraverso comunicazioni elettroniche 
            (email, telefono, videochiamata) per la gestione della mia richiesta di quotazione. <span className="text-red-500">*</span>
          </span>
        </label>
        {errors.consensoConsulenza && <p className="text-red-500 text-sm mt-2">{errors.consensoConsulenza}</p>}
      </div>
      
      {/* Nota Precontrattuale */}
      <div className="bg-[#2B7A9F]/5 border border-[#2B7A9F]/10 rounded-lg p-4 text-xs text-gray-600 leading-relaxed">
        <strong>Nessun vincolo contrattuale:</strong> l'invio della presente richiesta ha finalità esclusivamente di preventivo e non ti impegna in alcun modo all'acquisto. Prima dell'eventuale sottoscrizione riceverai gratuitamente tutta la <a href="/precontrattuale" target="_blank" rel="noopener noreferrer" className="text-[#2B7A9F] underline">documentazione precontrattuale</a> prevista dalla normativa IVASS (Allegati, DIP e DIP Aggiuntivo).
      </div>
    </div>
  );

  if (submitStatus === 'success') {
    return (
      <div className="text-center py-12 animate-fade-in">
        <div className="w-20 h-20 bg-[#5FB76E]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="text-[#5FB76E]" size={40} />
        </div>
        <h3 className="text-2xl font-bold text-[#5FB76E] mb-4">Richiesta Inviata con Successo!</h3>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          Grazie per aver compilato la scheda di quotazione. Ti contatteremo entro 24-48 ore lavorative 
          all'indirizzo email fornito.
        </p>
        <button
          onClick={() => {
            setSubmitStatus(null);
            setCurrentStep(1);
            setFormData({
              ente: '', codiceFiscale: '', indirizzo: '', capCitta: '', email: '', telefono: '', referente: '',
              tipologiaEnte: '', descrizioneAttivita: [], descrizioneAttivitaAltro: '', iscrittoRUNTS: '',
              richiestaContatto: [], richiestaContattoAltro: '', presenzaProfessionisti: [], presenzaProfessionistiAltro: '',
              fatturatoAnnuo: '', numeroIscritti: '', numeroUtenti: '', numeroVolontari: '', registroVolontariVidimato: '',
              dataInizioEvento: '', dataFineEvento: '', sinistroRCT: '', sinistroRCTSpecifica: '',
              sinistroInfortuni: '', sinistroInfortuniSpecifica: '',
              files: { statuto: null, registroVolontari: null, documentoIdentita: null, documentazioneBando: null, polizzaAttuale: null },
              consensoConsulenza: false
            });
          }}
          className="bg-[#2B7A9F] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#2B7A9F]/90 transition-all"
        >
          Nuova Richiesta
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto">
      {renderStepIndicator()}
      
      <form onSubmit={handleSubmit}>
        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8">
          {currentStep === 1 && renderStep1()}
          {currentStep === 2 && renderStep2()}
          {currentStep === 3 && renderStep3()}
          {currentStep === 4 && renderStep4()}
          {currentStep === 5 && renderStep5()}
          {currentStep === 6 && renderStep6()}
          
          {submitStatus === 'error' && (
            <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-3">
              <AlertCircle className="text-red-500" size={20} />
              <span className="text-red-700">Si è verificato un errore. Riprova più tardi.</span>
            </div>
          )}
          
          {/* Navigation Buttons */}
          <div className="flex justify-between mt-8 pt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={prevStep}
              disabled={currentStep === 1}
              className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-semibold transition-all ${
                currentStep === 1 
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <ChevronLeft size={20} />
              <span>Indietro</span>
            </button>
            
            {currentStep < totalSteps ? (
              <button
                type="button"
                onClick={nextStep}
                className="flex items-center space-x-2 px-6 py-3 rounded-lg font-semibold bg-gradient-to-r from-[#2B7A9F] to-[#3AAFA9] text-white hover:shadow-lg hover:scale-105 transition-all"
              >
                <span>Avanti</span>
                <ChevronRight size={20} />
              </button>
            ) : (
              <button
                type="submit"
                disabled={isSubmitting}
                className="flex items-center space-x-2 px-8 py-3 rounded-lg font-semibold bg-gradient-to-r from-[#5FB76E] to-[#3AAFA9] text-white hover:shadow-lg hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    <span>Invio in corso...</span>
                  </>
                ) : (
                  <>
                    <Send size={20} />
                    <span>Invia Richiesta</span>
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default QuotazioneForm;
